module.exports = __webpack_public_path__ + "static/img/15.3edab16.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/zh/15.png
// module id = 1zK2
// module chunks = 0